// import { createSlice } from "@reduxjs/toolkit";
// import {
//   getShiprocketUser,
//   createShiprocketUser,
//   getShipRocketDetail, 
// } from "./ThunkActions";
// import { iShiprocketState, REDUCER_NAME } from "./Types";

// const initialState: iShiprocketState = {
//   isLoading: false,
//   shiprocketUser: null,
//   errorMessage: null,
// };

// export const shiprocketSlice = createSlice({
//   name: REDUCER_NAME,
//   initialState,
//   reducers: {
//     resetShiprocketState: () => initialState,
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(getShiprocketUser.pending, (state) => {
//         state.isLoading = true;
//       })
//       .addCase(getShiprocketUser.fulfilled, (state, action) => {
//         const payload = action.payload;
//         if (payload && payload.data) {
//           state.shiprocketUser = payload.data.data;
//         }
//         state.isLoading = false;
//       })
//       .addCase(getShiprocketUser.rejected, (state) => {
//         state.errorMessage = "Failed to fetch Shiprocket user data";
//         state.isLoading = false;
//       })

//       .addCase(createShiprocketUser.pending, (state) => {
//         state.isLoading = true;
//       })
//       .addCase(createShiprocketUser.fulfilled, (state, action) => {
//         const payload = action.payload;
//         if (payload && payload.data) {
//           state.shiprocketUser = payload.data.shiprocketUser;
//         }
//         state.isLoading = false;
//       })
//       .addCase(createShiprocketUser.rejected, (state) => {
//         state.errorMessage = "Failed to create Shiprocket user";
//         state.isLoading = false;
//       })

//       // ✅ New case for getShipRocketDetail
//       .addCase(getShipRocketDetail.pending, (state) => {
//         state.isLoading = true;
//       })
//       .addCase(getShipRocketDetail.fulfilled, (state, action) => {
//         const payload = action.payload;
//         if (payload && payload.data) {
//           state.shiprocketUser = payload.data.data;
//         }
//         state.isLoading = false;
//       })
//       .addCase(getShipRocketDetail.rejected, (state, action) => {
//         // @ts-expect-error
//         state.errorMessage =action.payload?.message || "Failed to fetch Shiprocket order detail";
//         state.isLoading = false;
//       });
//   },
// });

// export const { resetShiprocketState } = shiprocketSlice.actions;
// export default shiprocketSlice.reducer;



import { createSlice } from "@reduxjs/toolkit";
import {
  getShiprocketUser,
  createShiprocketUser,
  getShipRocketDetail,
  shipRocketOrderTrack, // ✅ import the new thunk
} from "./ThunkActions";
import { iShiprocketState, REDUCER_NAME } from "./Types";

const initialState: iShiprocketState = {
  isLoading: false,
  shiprocketUser: null,
  errorMessage: null,
};

export const shiprocketSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetShiprocketState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      // 🚀 Get Shiprocket user
      .addCase(getShiprocketUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getShiprocketUser.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.shiprocketUser = payload.data.data;
        }
        state.isLoading = false;
      })
      .addCase(getShiprocketUser.rejected, (state) => {
        state.errorMessage = "Failed to fetch Shiprocket user data";
        state.isLoading = false;
      })

      // 🚀 Create Shiprocket user
      .addCase(createShiprocketUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createShiprocketUser.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.shiprocketUser = payload.data.shiprocketUser;
        }
        state.isLoading = false;
      })
      .addCase(createShiprocketUser.rejected, (state) => {
        state.errorMessage = "Failed to create Shiprocket user";
        state.isLoading = false;
      })

      // 🚚 Get ShipRocket detail
      .addCase(getShipRocketDetail.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getShipRocketDetail.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.shiprocketUser = payload.data.data;
        }
        state.isLoading = false;
      })
      .addCase(getShipRocketDetail.rejected, (state, action) => {
        // @ts-expect-error
        state.errorMessage = action.payload?.message || "Failed to fetch Shiprocket order detail";
        state.isLoading = false;
      })

      // 📦 Track ShipRocket order (NEW)
      .addCase(shipRocketOrderTrack.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(shipRocketOrderTrack.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.shiprocketUser = payload.data.data; // Or create a separate state key if needed
        }
        state.isLoading = false;
      })
      .addCase(shipRocketOrderTrack.rejected, (state, action) => {
        // @ts-expect-error
        state.errorMessage = action.payload?.message || "Failed to fetch Shiprocket tracking details";
        state.isLoading = false;
      });
  },
});

export const { resetShiprocketState } = shiprocketSlice.actions;
export default shiprocketSlice.reducer;
